import { FC } from 'react'
import { UserProtectedRoute } from 'routes'
import BoardsPost from 'components/BoardsPost'

const BoardsPostPage: FC = () => {
  return (
    <UserProtectedRoute>
      <BoardsPost />
    </UserProtectedRoute>
  )
}

export default BoardsPostPage
